const React = require("react");
const { useParams } = require("react-router-dom");
const { useSyncee } = require("../context/SynceeContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingSupplierProducts = () => { const { supplierId } = useParams(); const { t } = useSyncee(); return h(ProductCollectionPage, { supplierId, title: t("h_syncee_supplier_products", "Supplier products"), description: t("h_syncee_supplier_products_desc", "Designed products available in this Syncee store.") }); };
module.exports = { DropshippingSupplierProducts };
